import React, { useEffect } from 'react';
import { Grid } from 'semantic-ui-react';
import { getObjPropRecursively } from '../../utils';
import { useState } from 'react';
import UserDateActionRequired from './UserDateActionRequired';
import UserInput from './UserInput';
import UserDateAdvancedDatePicker from './UserDateAdvancedDatePicker';

type Props = {
  columns?: number;
  closable?: boolean;
  renderDefaultButtons?: boolean;
  initialData: { currentUser: any };
  userName: string;
  setFieldValue: (value: any, name?: string) => void;
  userLabel?: string;
  dteLabel?: string;
  dteName?: string;
  setMarkAsChecked?: () => void;
  toggleValidationMessage: () => void;
  renderOther?: (props: any) => void;
  openDirection?: string;
  isInventory?: boolean;
  setValidateOnChange: (value: boolean) => void;
  formikProps?: any;
  accordionTooltip?: string;
  values?: any;
  errors?: any;
  showPersonalData?: boolean;
  disabled?: boolean;
  accordionTitle?: string;
};

const UserDateInformationContentContainer: React.FC<Props> = ({ ...props }) => {
  const [userDateValidation, setUserDateValidation] = useState(0);
  const { currentUser } = props.initialData;
  const { userName, setFieldValue } = props;

  const updateUserDateFieldsValidation = () => {
    setUserDateValidation(userDateValidation + 1);
  };

  const setDefaultUser = (clear: boolean) => {
    setFieldValue(userName, clear ? null : currentUser);
  };

  const {
    values,
    errors,
    userLabel,
    dteLabel,
    setMarkAsChecked,
    toggleValidationMessage,
    dteName,
    renderOther,
    openDirection,
    renderDefaultButtons,
    isInventory,
    setValidateOnChange,
    formikProps,
  } = props;

  let userValue = getObjPropRecursively(values, userName);
  let dteValue = getObjPropRecursively(values, dteName);

  const userValueUpdated = Object.assign({}, userValue);

  if (userValueUpdated && userValueUpdated.name && !props.showPersonalData) {
    userValueUpdated.name = userValueUpdated.name.replace(/[a-z]/g, 'x');
  }

  return (
    <Grid stackable doubling columns={props.columns} verticalAlign="bottom">
      {setMarkAsChecked && (
        <UserDateActionRequired
          values={values}
          isInventory={isInventory}
          setValidateOnChange={setValidateOnChange}
          toggleValidationMessage={toggleValidationMessage}
          setMarkAsChecked={setMarkAsChecked}
          submitForm={formikProps?.submitForm}
        />
      )}
      <Grid.Row>
        <UserInput
          {...props}
          userName={userName}
          userLabel={userLabel}
          dteName={dteName}
          dteLabel={dteLabel}
          renderDefaultButtons={renderDefaultButtons}
          setDefaultUser={setDefaultUser}
          updateUserDateFieldsValidation={updateUserDateFieldsValidation}
          errors={errors}
          userValue={userValueUpdated}
          dteValue={dteValue}
        />

        <UserDateAdvancedDatePicker
          {...props}
          dteValue={dteValue}
          dteName={dteName}
          dteLabel={dteLabel}
          openDirection={openDirection}
          renderDefaultButtons={renderDefaultButtons}
          updateUserDateFieldsValidation={updateUserDateFieldsValidation}
          userValue={userValue}
        />

        {renderOther && renderOther(props)}
      </Grid.Row>
    </Grid>
  );
};

export default UserDateInformationContentContainer;
